
var statusColors = {
    submitted: 'green',
    not_submitted: 'muted',
    late: 'yellow',
    very_late: 'red',
};

var statusLabels = {
    submitted: 'Submitted',
    not_submitted: 'Not Submitted',
    late: 'Late',
    very_late: 'Very Late',
};


module.config(function($stateProvider, TagUrl) {

    var programUrl = new TagUrl()
        .addTagTypes(['program', 'location'])
        .setTagDefault('affiliation', 'all')
        .addSorterParams('submitted', 'desc')
        .addPagerParams()
        .addExtraParam('status', 'all');

    $stateProvider.state('reports.submission', {
        url: programUrl.buildUrl('/submission'),
        params: programUrl.params,
        reloadOnSearch: false,
        templateUrl: 'reports/history/submission',
        data: {tagUrl: programUrl},
        controller: 'SubmissionReportController',
        controllerAs: 'ctrl',
    });

    $stateProvider.state('program.reports.submission', {
        url: '/submission?{page}',
        params: {page: {value: 1, squash: true, type: 'int'}},
        reloadOnSearch: false,
        templateUrl: 'reports/history/programSubmission',
        controller: 'ProgramSubmissionReportController',
        controllerAs: 'ctrl',
        resolve: {
            report: function(program, $stateParams, ProgramSubmissionReport) {
                var report = new ProgramSubmissionReport(program);
                report.pager.page = $stateParams.page;
                return report.update();
            },
        },
    });

});


module.service('SubmissionReport', function(Report, $state) {

    Report.makeChildClass(SubmissionReport);
    function SubmissionReport(status) {
        this._status = status;
        Report.call(this, ['reports/submission']);
    }
    SubmissionReport.prototype.$isList = true;
    SubmissionReport.prototype.$sorterConfig = {
        default: 'submitted', direction: 'desc',
        columns: ['name', 'login', 'submitted', 'issues'],
    };

    Report.addExtraParameter(SubmissionReport, 'status', function(name, value) {
        params = {};
        params[name] = value;
        $state.go('.', params, {location: 'replace'});
    });

    return SubmissionReport;
});


module.service('ProgramSubmissionReport', function(Report) {
    function ProgramSubmissionReport(program) {
        url = ['program', program.id, 'submissions'];
        Report.call(this, url);
    }

    Report.makeChildClass(ProgramSubmissionReport);
    ProgramSubmissionReport.prototype.$isList = true;
    return ProgramSubmissionReport;
});


module.cC({
    name: 'SubmissionReportController',
    inject: ['SubmissionReport', '$stateParams', 'ApiUrl', 'FileService', '$scope'],
    data: {statusColors: statusColors, statusLabels: statusLabels},
    init: function() {
        this.report =  new this.SubmissionReport(this.$stateParams.status);

        this.sortOptions = [
            {name: 'submitted', label: 'Last Verification', desc: true},
            {name: 'name', label: 'Program Name'},
            {name: 'login', label: 'Last Login', desc: true},
            {name: 'issues', label: 'Issue Count'},
        ];

        this.pills = [
            {name: 'All', value: "all"},
            {name: 'Submitted', value: 'submitted'},
            {name: 'Not Submitted', value: 'not_submitted'},
            {name: 'Late', value: 'late'},
            {name: 'Very Late', value: 'very_late'},
        ];

    },

    methods: {
        refresh: function(params) {
            this.lastParams = params;
            this.report.update(params);
        },
        downloadFile: function() {
            var ctrl = this;
            var url = this.ApiUrl('reports', 'submission', 'export')
            this.downloading = true
            this.FileService.downloadFile(url, this.lastParams).then(function() {
                ctrl.downloading = false;
            });
        }
    },
});


module.cC({
    name: 'ProgramSubmissionReportController',
    inject: ['report', 'ModelService'],
    data: {statusColors: statusColors, statusLabels: statusLabels},
    methods: {
        deleteSubmission: function(id) {
            return this.ModelService.delete('submission', id);
        },
    }
});


